export const facebookTrackEvent = (event_name, data) => {
    if (typeof fbq === 'function') {
        fbq('track', event_name, data)
    }
}